module.exports = __webpack_public_path__ + "static/media/fires_i_mercats.69b895d3.jpg";